// extracted by mini-css-extract-plugin
export var callOutList = "ArticleCallOutIconList-module--callOutList--tRuC7";